export const HOME = "HOME_PAGE";

export const DEBTORS_LIST = "DEBTORS_PAGE";
export const CREATE_DEBTOR = "CREATE_DEBTOR_PAGE";
export const DEBTOR_DETAIL = "DETAILS_DEBTORS_PAGE";

export const PAYMENT_PLAN_LIST = "PAYMENT_PLAN_LIST_PAGE";
export const PAYMENT_PLAN_CREATE = "PAYMENT_PLAN_CREATE";
export const PAYMENT_PLAN_DETAIL = "PAYMENT_PLAN_DETAIL";
export const PAYMENT_PLAN_DETAIL_PUBLIC_ACCESS =
  "PAYMENT_PLAN_DETAIL_PUBLIC_ACCESS";

export const PAYMENT_LIST = "PAYMENT_LIST_PAGE";
export const PAYMENT_DETAIL = "PAYMENT_DETAIL";
export const CREDITOR_PAYMENT_LIST = "CREDITOR_PAYMENT_LIST";
export const CREDITOR_PAYMENT_DETAIL = "CREDITOR_PAYMENT_DETAIL";

export const USER_DETAIL = "PROFILE_PAGE";
export const USERS_LIST = "USERS_LIST_PAGE";

export const INTERNAL_USERS_LIST = "INTERNAL_USERS_LIST";

export const LOGIN = "LOGIN_PAGE";
export const FORGOT_PASSWORD = "FORGOT_PASSWORD_PAGE";
export const RESET_PASSWORD = "RESET_PASSWORD_PAGE";
export const REGISTER = "REGISTER_PAGE";

export const LOGOUT = "LOGOUT_ACTION";

const routePaths = {
  [HOME]: "/",

  [DEBTORS_LIST]: "/patients",
  [CREATE_DEBTOR]: "/patients/create",
  [DEBTOR_DETAIL]: "/patients/details/:id",

  [PAYMENT_PLAN_LIST]: "/payment-plan",
  [PAYMENT_PLAN_CREATE]: "/payment-plan/create",
  [PAYMENT_PLAN_DETAIL]: "/payment-plan/details/:id",
  [PAYMENT_PLAN_DETAIL_PUBLIC_ACCESS]: "/payment-plan/public-access/:token",

  [PAYMENT_LIST]: "/payment",
  [PAYMENT_DETAIL]: "/payment/details/:id",
  [CREDITOR_PAYMENT_LIST]: "/creditor-payment",
  [CREDITOR_PAYMENT_DETAIL]: "/creditor-payment/details/:id",

  [USERS_LIST]: "/users",
  [USER_DETAIL]: "/users/:id",
  [INTERNAL_USERS_LIST]: "/internal-users",

  [LOGOUT]: "/logout",
  [LOGIN]: "/login",
  [FORGOT_PASSWORD]: "/forgot-password",
  [REGISTER]: "/register",
  [RESET_PASSWORD]: "/reset-password/:token",
};

export function getRoute(route) {
  return routePaths.hasOwnProperty(route)
    ? process.env.PUBLIC_URL + routePaths[route]
    : process.env.PUBLIC_URL + "/not-found-route";
}

export function getUrl(route, params) {
  let resultUrl = getRoute(route);
  if (params) {
    for (var key in params) {
      resultUrl = resultUrl.replace("/:" + key + "/", "/" + params[key] + "/");
      if (resultUrl.endsWith("/:" + key)) {
        resultUrl = resultUrl.replace("/:" + key, "/" + params[key]);
      }
    }
  }
  return resultUrl;
}
